import doc         from '@widesk-core/decorators/doc';
import ImportModel from './ImportModel';

@doc.path('/imports/check_url')
export default class ImportCheckUrlModel extends ImportModel {}
